(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tipi-growth-layer"] && !Shopify.designMode) return;
  try {
    
  (()=>{document.querySelectorAll('[data-tipi-growth]').forEach(root=>{if(root.dataset.offerReady)return;root.dataset.offerReady='1';const dialog=root.querySelector('[data-tipi-offer]');if(!dialog)return;const key='tipi-welcome-offer-seen';const open=()=>{if(!dialog.open)dialog.showModal()};root.querySelector('[data-tipi-offer-open]')?.addEventListener('click',open);root.querySelector('[data-tipi-offer-close]')?.addEventListener('click',()=>{dialog.close();localStorage.setItem(key,'1')});dialog.addEventListener('click',event=>{if(event.target===dialog){dialog.close();localStorage.setItem(key,'1')}});if(!localStorage.getItem(key))setTimeout(open,9000)});})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tipi-product-experience"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-tipi-product]').forEach((root) => {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';

      const main = root.querySelector('.tipi-product__main-image');
      const variantInput = root.querySelector('[data-tipi-variant-input]');
      const price = root.querySelector('[data-tipi-price]');
      const buttonPrice = root.querySelector('[data-tipi-button-price]');
      const selection = root.querySelector('[data-tipi-selection]');
      const upload = root.querySelector('[data-tipi-upload]');
      const uploadState = root.querySelector('[data-tipi-upload-state]');
      const fileName = root.querySelector('[data-tipi-file-name]');
      const quality = root.querySelector('[data-tipi-quality]');
      const otherColorWrap = root.querySelector('[data-tipi-color-other]');
      const otherColorInput = otherColorWrap?.querySelector('input');
      let pixels = { width: 0, height: 0 };

      const setMainImage = (src, alt = '') => {
        if (!main) return;
        main.removeAttribute('srcset');
        main.removeAttribute('sizes');
        main.src = src;
        if (alt) main.alt = alt;
      };

      const getSize = () => {
        const title = root.querySelector('[data-tipi-variant].is-selected')?.dataset.title || '';
        const found = title.match(/(\d+(?:\.\d+)?)\D+[x×]\D*(\d+(?:\.\d+)?)/i);
        return found ? { width: Number(found[1]), height: Number(found[2]) } : null;
      };

      const checkQuality = () => {
        if (!quality || !pixels.width) return;
        const size = getSize();
        if (!size) return;
        const orientation = root.querySelector('[data-tipi-orientation]')?.value || 'Portrait';
        if (orientation === 'Landscape' && size.width < size.height) [size.width, size.height] = [size.height, size.width];
        const dpi = Math.floor(Math.min(pixels.width / size.width, pixels.height / size.height));
        const grade = dpi >= 300 ? 'excellent' : dpi >= 150 ? 'good' : 'low';
        const key = grade.charAt(0).toUpperCase() + grade.slice(1);
        quality.hidden = false;
        quality.dataset.grade = grade;
        quality.querySelector('[data-tipi-quality-title]').textContent = root.dataset[`quality${key}`];
        quality.querySelector('[data-tipi-quality-copy]').textContent = `${root.dataset[`quality${key}Copy`]} ${dpi} DPI.`;
      };

      root.querySelectorAll('[data-tipi-thumb]').forEach((button) => {
        button.addEventListener('click', () => {
          setMainImage(button.dataset.src, button.dataset.alt);
          root.querySelectorAll('[data-tipi-thumb]').forEach((item) => {
            const active = item === button;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
        });
      });

      root.querySelectorAll('[data-tipi-variant]').forEach((button) => {
        button.addEventListener('click', () => {
          root.querySelectorAll('[data-tipi-variant]').forEach((item) => {
            const active = item === button;
            item.classList.toggle('is-selected', active);
            item.setAttribute('aria-checked', active ? 'true' : 'false');
          });
          if (variantInput) variantInput.value = button.dataset.id;
          if (price) price.textContent = button.dataset.price;
          if (buttonPrice) buttonPrice.textContent = button.dataset.price;
          if (selection) selection.textContent = button.dataset.title;
          checkQuality();
        });
      });

      root.querySelectorAll('[data-tipi-colors] input[type="radio"]').forEach((radio) => {
        radio.addEventListener('change', () => {
          const showOther = radio.hasAttribute('data-tipi-color-other-option');
          if (otherColorWrap) otherColorWrap.hidden = !showOther;
          if (otherColorInput) {
            otherColorInput.disabled = !showOther;
            otherColorInput.required = showOther;
            if (!showOther) otherColorInput.value = '';
          }
        });
      });

      upload?.addEventListener('change', () => {
        const file = upload.files?.[0];
        if (!file) return;
        if (fileName) fileName.textContent = file.name;
        if (uploadState) uploadState.hidden = false;
        if (file.type.startsWith('image/') && main) {
          const url = URL.createObjectURL(file);
          const probe = new Image();
          probe.onload = () => {
            pixels = { width: probe.naturalWidth, height: probe.naturalHeight };
            setMainImage(url, file.name);
            checkQuality();
          };
          probe.src = url;
        }
      });

      root.querySelector('[data-tipi-orientation]')?.addEventListener('change', checkQuality);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
